import { Grid, Typography } from "@material-ui/core";
import moment from "moment/moment";
import { useRankingClienteService } from "../../context/RankingClienteContext";

export const ReportHeader = () => {
  const { cachedPeriod: period, filters } = useRankingClienteService();

  const startDate = moment(
    period?.startDate,
    filters.period === "YYYY-MM-DD"
  ).format("DD/MM/YYYY");

  const endDate = moment(
    period?.endDate,
    filters.period === "YYYY-MM-DD"
  ).format("DD/MM/YYYY");

  return (
    <Grid item xs>
      <Typography variant="h4">Relatório de Ranking de Clientes</Typography>

      <Typography variant="subtitle2">
        Busca realizada entre: {startDate} e {endDate}
      </Typography>
    </Grid>
  );
};
